import OpenCaseByLink from './OpenCaseByLink';

export default OpenCaseByLink;
